import { render, staticRenderFns } from "./AddrList.vue?vue&type=template&id=0c2bd15a&"
import script from "./AddrList.vue?vue&type=script&lang=js&"
export * from "./AddrList.vue?vue&type=script&lang=js&"
import style0 from "./AddrList.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports